var map = {
	"./rz.png": "OkFs",
	"./rzHover.png": "byVE"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "LOev";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/funImg ^\.\/rz.*\.png$
// module id = LOev
// module chunks = 1